import React, { useEffect, useState } from "react";

import lavage1 from "../assets/images/lavage1.jpg";
import lavage2 from "../assets/images/lavage2.jpg";
import laverie from "../assets/images/laverie1.jpg";
import laverie2 from "../assets/images/consolelaverie.jpeg";

const lavageImages = [lavage1, lavage2];
const laverieImages = [laverie2, laverie]; // console d'abord puis laverie

const ProjetsRecents = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const [currentLaverieImage, setCurrentLaverieImage] = useState(0);

  useEffect(() => {
    const lavageInterval = setInterval(() => {
      setCurrentImage((prev) =>
        prev === lavageImages.length - 1 ? 0 : prev + 1
      );
    }, 3000);

    const laverieInterval = setInterval(() => {
      setCurrentLaverieImage((prev) =>
        prev === laverieImages.length - 1 ? 0 : prev + 1
      );
    }, 3000);

    return () => {
      clearInterval(lavageInterval);
      clearInterval(laverieInterval);
    };
  }, []);

  return (
    <section className="w-full bg-white py-20 px-6">
      {/* TITRE */}
      <div className="text-center mb-14">
        <h3 className="text-4xl md:text-5xl font-black text-blue-600 uppercase mb-4">
          Nos Projets Récents
        </h3>

        <p className="text-gray-500 max-w-3xl mx-auto">
          J-Tronics accompagne ses clients dans la réalisation de projets de
          lavage et de laveries self-service en Tunisie. Grâce à son expertise
          et à ses solutions innovantes, l'entreprise développe des
          installations performantes, fiables et adaptées aux besoins de chaque
          projet.
        </p>
      </div>

      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-stretch">
        {/* PROJET LAVAGE */}
        <div>
          <h3 className="text-2xl font-bold text-yellow-500 mb-6 text-center">
            Let's Wash Park – Médenine
          </h3>

          <div className="max-w-5xl mx-auto flex flex-col h-full">
            <div className="relative overflow-hidden rounded-2xl group shadow-lg">
              <img
                src={lavageImages[currentImage]}
                alt="Projet Lavage Médenine"
                className="w-full h-[420px] object-contain transition-all duration-700"
              />

<div className="absolute inset-0 bg-black/70 opacity-100 md:opacity-0 md:group-hover:opacity-100 transition duration-300 flex items-center justify-center p-6">
                <p className="text-white text-center leading-relaxed">
                  Réalisation d'une station de lavage à Médenine intégrant des
                  équipements modernes et performants. Ce projet a été conçu
                  pour offrir une utilisation simple, une grande fiabilité et
                  une qualité de service optimale.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* PROJET LAVERIE */}
        <div>
          <h3 className="text-2xl font-bold text-yellow-500 mb-6 text-center">
            Let's Clean – Sfax
          </h3>

          <div className="max-w-5xl mx-auto flex flex-col h-full">
            <div className="relative overflow-hidden rounded-2xl group shadow-lg">
              <img
                src={laverieImages[currentLaverieImage]}
                alt="Projet Laverie Sfax"
                className="w-full h-[420px] object-contain transition duration-500 group-hover:scale-105"
              />

<div className="absolute inset-0 bg-black/70 opacity-100 md:opacity-0 md:group-hover:opacity-100 transition duration-300 flex items-center justify-center p-8">
                <p className="text-white text-center leading-relaxed">
                  Mise en place d'une laverie self-service moderne à Sfax
                  offrant aux utilisateurs un accès autonome à des machines
                  performantes. Cette installation a été pensée pour assurer
                  confort, rapidité et disponibilité continue.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjetsRecents;